/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {
  // $('.image-overlay__items').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   dots:true,
  //   arrows:false,
  //   mobileFirst: true,
  //   responsive: [
  //     {
  //       breakpoint: 741,
  //       settings: "unslick"
  //     }
  //   ]
  // });

  if ($(window).width() <= 740) {
    if (!$('.image-overlay__items').hasClass('slick-initialized')) {
      $('.image-overlay__items').slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: false
      });
    }
  } else {
    if ($('.image-overlay__items').hasClass('slick-initialized')) {
      $('.image-overlay__items').slick('unslick');
    }
  }

  // TESTIMONIAL SECONDARY
  $('.testimonial-secondary-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          dots:true,
          arrows:false
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // CONTACT US
  $('.contact-us-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    arrows:false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
  });

  // TEXT WITH ICON SECONDARY
  if ($(window).width() <= 740) {
    if (!$('.text-with-icon-secondary-list').hasClass('slick-initialized')) {
      $('.text-with-icon-secondary-list').slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: false
      });
    }
  } else {
    if ($('.text-with-icon-secondary-list').hasClass('slick-initialized')) {
      $('.text-with-icon-secondary-list').slick('unslick');
    }
  }

  // COMPLEMENTARY PRODUCTS
  setTimeout(function() {
    $('.complementary-products__inner').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      mobileFirst: false,
      responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 999,
        settings: "unslick"
      }
    ]
    });
  }, 1000)

  // HUMAN HARISSONS
  $('.human-harissons-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // BLOG POSTS SECONDARY
  $('.article-list-secondary').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          dots:true,
          arrows:false
        }
      }
    ]
  });

  // JOURNEY INCEPTION  
   $('.journey-inception-main-slider').slick({
     slidesToShow: 1,
     slidesToScroll: 1,
     dots: false,
     focusOnSelect: true,
     centerMode: true,
     responsive: [
      {
        breakpoint: 999,
        settings: {
          dots:true,
          arrows:false
        }
      }
    ]
   });
  
   $('.journey-inception-nav-slider-item').click(function(e) {
     e.preventDefault();
     $(this).addClass('active').siblings().removeClass('active');
     var slideno = $(this).data('slide');
     $('.journey-inception-main-slider').slick('slickGoTo', slideno - 1);
   });

  // PRODUCT TAB NAVIGATION
    function scrollToSection(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    $(".product-tab-iner a").removeClass("active");
    $(this).addClass("active");
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 240,      
        },
        500
      ); 
    } else {
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 0,      
        },
        500
      );
    }   
  }
  $(".ptb_link").on("click", scrollToSection);

  function scrollToSectionn(event) {
    var width = $(window).outerWidth();
    event.preventDefault();
    var $section = $($(this).attr("href"));
    if(width>=999){
       $("html, body").animate(
        {
          scrollTop: $section.offset().top - 240,      
        },
        500
      ); 
    } else {
      $('#additoinal-info').find('.section_accordion_button_heading').click();
      $("html, body").animate(
        {
          scrollTop: $section.offset().top - 100,      
        },
        500
      );
    }   
  }
  $(".product-warranty-button, .button-scroll-to-section").on("click", scrollToSectionn);

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).siblings('.offer-code-wrap-code').text();
    var $temp = $("<input>");
      
    $("drawer-content").append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html('Copy');
    }, 1000);
  });

  $('.section_accordion_button_heading').click(function(){
    $(this).toggleClass('active');
    $(this).next('.section_accordion_content').slideToggle();
  });
  

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var elementMidpoint = elementTop + $(this).outerHeight() / 2;
    return elementMidpoint > viewportTop && elementMidpoint < viewportBottom;
  };
  $(window).scroll(function() {
    var scrollDistance = $(window).scrollTop() + 310;
    var count = 0;
    $('.page-section').each(function(i) {
      if ($(this).isInViewport()) {
       $('.product-tab-row a.active').removeClass('active');
       $('.product-tab-row a').eq(i).addClass('active');
        count++
      }
    });
    if (count === 0) {
         $('.shopify-section--product-tab-nav').addClass('no-active-sections');
    } else {
       $('.shopify-section--product-tab-nav').removeClass('no-active-sections');
    }
  }).scroll();

  // TYPEWRITER INPUT
  const inputElement = document.getElementById("typewriter");
  var valuee = window.themeVariables.settings.typewriter;
  var textsToType = valuee.split(',');
    let textIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    function typeWriter() {
      const currentText = textsToType[textIndex];
      if (isDeleting) {
        // Update the placeholder by removing characters
        inputElement.placeholder = currentText.substring(0, charIndex);
        charIndex--;

        if (charIndex < 0) {
          isDeleting = false;
          textIndex = (textIndex + 1) % textsToType.length; // Move to the next text or loop
          setTimeout(typeWriter, 200); // Delay before typing the next text
        } else {
          setTimeout(typeWriter, 30); // Deleting speed
        }
      } else {
        // Update the placeholder by adding characters
        inputElement.placeholder = currentText.substring(0, charIndex);
        charIndex++;

        if (charIndex > currentText.length) {
          isDeleting = true;
          setTimeout(typeWriter, 1000); // Delay before starting to delete
        } else {
          setTimeout(typeWriter, 100); // Typing speed
        }
      }
    }
    setTimeout(typeWriter, 1000);

  
    // Select the section and the element to hide
    var section = document.querySelector('.footer');
    var elementToHide = document.querySelector('.enquire-button-section');
    
     function checkVisibility() {
      var rect = section.getBoundingClientRect();
      var isVisible = rect.top < window.innerHeight && rect.bottom > 0;
  
      // Toggle visibility of the element based on the section's visibility
      if (isVisible) {
        elementToHide.style.display = 'none';  // Hide the element
      } else {
        elementToHide.style.display = 'block'; // Show the element
      }
    }
    if(elementToHide){
      // Attach the scroll event
      window.addEventListener('scroll', checkVisibility);
      checkVisibility() 
    }   

  // Clear URL parameters without reloading the page
  function clearURLParameters() {
    // Get the current URL
    const url = new URL(window.location.href);
  
    // Remove all query parameters
    url.search = "";
  
    // Optionally, remove the fragment (everything after #)
    url.hash = "";
  
    // Update the URL without reloading the page
    window.history.replaceState(null, null, url.toString());
  }
  
  var live_url = window.location.href;
  var result = live_url.includes('form_type=customer');
  var resultischal = live_url.includes('/challenge');
  if(live_url.includes('customer_posted=true')){
    $('html, body').animate({
        scrollTop: $('.newsletter-secondary-inner').offset().top - 100
    }, 1000);
  }else if(result && !resultischal && $('.newsletter_form_sec').length != 0 && $('.newsletter_form_sec .errors').length == 0){
      const add_ele = document.createElement("p");
      add_ele.innerText = "You have already subscribed!";
      $('.newsletter_form_sec').prepend(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form_message','form_message');     
      clearURLParameters();
      $('html, body').animate({
          scrollTop: $('.newsletter-secondary-inner').offset().top - 100
      }, 1000);
    // Scroll to the `.newsletter_form_sec` section and center it on the screen
    // const newsletterSection = document.querySelector('.newsletter-secondary-container');
    // if (newsletterSection) {
    //   newsletterSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //   console.log('Scrolled to newsletter section');
    // } else {
    //   console.log('Newsletter section not found');
    // }
  }  

  
  if(document.getElementById("continuous_timerr") && $(".continuous-timer-main").length > 0){
  
    // Set the countdown duration (1 hour in milliseconds)
    var countDownHours = parseInt(document.querySelectorAll(".continuous_timer")[0].getAttribute("sale_countdown_time_hours")) || 0;
    var countDownMinutes = parseInt(document.querySelectorAll(".continuous_timer")[0].getAttribute("sale_countdown_time_minutes")) || 0;
    var countDownDuration = (countDownHours * 60 * 60 * 1000) + (countDownMinutes * 60 * 1000);
    
    // Check if there's a stored start time in localStorage
    var storedStartTime = localStorage.getItem("startTime");
    var startTime;
    
    // If there's no stored start time, initialize it to the current time
    if (storedStartTime) {
      startTime = parseInt(storedStartTime, 10);
    } else {
      startTime = new Date().getTime();
      localStorage.setItem("startTime", startTime);
    }
    
    // Update the countdown every 1 second
    var x = setInterval(function () {
      // Get the current time
      var now = new Date().getTime();
    
      // Calculate the time elapsed since the start time
      var elapsed = now - startTime;
    
      // Find the remaining time in the current countdown
      var distance = countDownDuration - (elapsed % countDownDuration);
    
      // Time calculations for hours, minutes, and seconds
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
      // Build the display string
      var display = "";
      if (hours > 0) {
        display += ` &nbsp;<span>${hours}h</span>`;
      }
      display += ` &nbsp;<span>${minutes}m</span>` + ` &nbsp;<span>${seconds}s</span>`;
      // console.log('displayyy',display);
      // Output the result in an element with id="demo"
      document.getElementById("continuous_timerr").innerHTML = display;
    
      // Reset the start time if a new countdown cycle begins
      if (distance <= 0) {
        startTime = new Date().getTime();
        localStorage.setItem("startTime", startTime);
      }
    }, 1000);
  }

  function setCookie(name, value, hours) {
    var date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  function getCookie(name) {
    var cname = name + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');

    for(var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(cname) == 0) {
        return c.substring(cname.length, c.length);
      }
    }

    return "";
  }

  if(!getCookie('quizpopupShown')){

    var delaytime = parseInt($('.qnp_main').attr('data-delaytime')) || 10000;

    setTimeout(function(){

      $('.qnp_main').addClass('active');

      setCookie('quizpopupShown', 'true', 24); // expires after 24 hours

    }, delaytime);

  }

  $('body').on('click','.qnp_main .pop_close_icon', function(){
    $(this).closest('.qnp_main').removeClass('active');
  });

  $('body').on('click','.qnp_main .continue_button', function(){
    console.log('innn')
    var currentstep = parseInt($(this).closest('.steps_wrapper').attr('data-step'));
    var nextstep = currentstep + 1;
    $('.steps_wrapper').hide();
    $('.steps_wrapper[data-step="'+nextstep+'"]').show();
      
    var formdata = {};
  
    formdata['initiated'] = 'Yes';

    var slug_name = 'harissons_usage_form';

    var qzdata = {
      "form_slug": slug_name,
      "step": parseInt(currentstep),
      "answers": formdata
    }
    
    console.log(qzdata)

    $.ajax({
      url: "https://dev.d2cbox.com/forms/api/v1/save/",
      method: "POST",
      contentType:"application/json",
      headers: {
        "Authorization": "a6b2b7b25aaf43e1b8ce2491d437801e"
      },
      data: JSON.stringify(qzdata),
      success: function (response) {
        console.log(response)
        sessionStorage.setItem('qz_popup_progress', JSON.stringify(response));
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        // _this.find('.banner--error').show();
      }
    });
    // stepupdate(nextstep);
  });

  $('body').on('click','.qnp_main .steps_wrapper input[type="radio"]', function(){
    console.log('innn222')
    var currentstep = parseInt($(this).closest('.steps_wrapper').attr('data-step'));
    console.log(currentstep);
    var nextstep = currentstep + 1;
    $('.steps_wrapper').hide();
    $('.steps_wrapper[data-step="'+nextstep+'"]').show();
    var progresscached = JSON.parse(sessionStorage.getItem('qz_popup_progress'));
    var formdata = {};
    
    var $input = $(this).closest('.quiz_question_answer').find('input[type="radio"]:checked');

    if ($input.length && $input.attr('name')) {
      formdata[$input.attr('name')] = $input.val();
    }

    var slug_name = 'harissons_usage_form';

    var qzdata = {
      "form_slug": slug_name,
      "step": parseInt(currentstep),
      "answers": formdata
    }
    if (progresscached) {
      qzdata['response_slug'] = progresscached.response_slug;
    }

    console.log(qzdata);
    $.ajax({
      url: "https://dev.d2cbox.com/forms/api/v1/save/",
      method: "POST",
      contentType:"application/json",
      headers: {
        "Authorization": "a6b2b7b25aaf43e1b8ce2491d437801e"
      },
      data: JSON.stringify(qzdata),
      success: function (response) {
        console.log(response);
        sessionStorage.setItem('qz_popup_progress', JSON.stringify(response));
        
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        // _this.find('.banner--error').show();
      }
    });
    

    // var currentstep = parseInt($(this).closest('.steps_wrapper').attr('data-step'));
    // var nextstep = currentstep + 1;
    // $('.steps_wrapper').hide();
    // $('.steps_wrapper[data-step="'+nextstep+'"]').show();
    // stepupdate(nextstep);
  });

  $('body').on('click','.qnp_main .qz_newsletter_submit', function(){
    console.log('innn')
    var _this = $(this);
    $('.error_msg').remove();
    var currentstep = parseInt($(this).closest('.steps_wrapper').attr('data-step'));
    var nextstep = currentstep + 1;
    const phoneRegex = /^[0-9]{10}$/; // exactly 10 digits
      
    var progresscached = JSON.parse(sessionStorage.getItem('qz_popup_progress'));
    var formdata = {};
    
    var $input = $(this).closest('.newsletter-secondary-input-row').find('input[name="whatsapp_number"]');
    const phone = $input.val();

    if (!phoneRegex.test(phone)) {
      $(_this).after(`<p class="error_msg">Please enter a valid 10 digit number.</p>`);
      return;
    }
    if ($input.length && $input.attr('name')) {
      formdata[$input.attr('name')] = $input.val();
    }
    formdata["tag"] = "Pop up";
    var slug_name = 'harissons_usage_form';

    var qzdata = {
      "form_slug": slug_name,
      "step": parseInt(currentstep),
      "answers": formdata
    }
    if (progresscached) {
      qzdata['response_slug'] = progresscached.response_slug;
    }
    
    console.log(qzdata)

    $.ajax({
      url: "https://dev.d2cbox.com/forms/api/v1/save/",
      method: "POST",
      contentType:"application/json",
      headers: {
        "Authorization": "a6b2b7b25aaf43e1b8ce2491d437801e"
      },
      data: JSON.stringify(qzdata),
      success: function (response) {
        sessionStorage.setItem('qz_popup_progress', JSON.stringify(response));
        console.log(response);
        if(response.status == 0){
          $(_this).after(`<p class="error_msg">You're already registered with us.</p>`);
        }else{
          $('.steps_wrapper').hide();
          $('.steps_wrapper[data-step="'+nextstep+'"]').show();
        }
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        // _this.find('.banner--error').show();
      }
    });
    // stepupdate(nextstep);
  });

  if($('[createCustomerForm]').length > 0){
   $('body').on('submit','[createCustomerForm]', function (e) {
      e.preventDefault(); // Prevent form submission
       var _this = $(this);
       _this.find('.banner--success,.banner--error').hide();
      const email = _this.find('#email').val();
      const phone = '91'+_this.find('#phone').val();
      const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format
  
      // Basic Validation
      if (!phoneRegex.test(phone)) {
        _this.find('.banner--error').show().find('.banner__content').html("Please enter a valid 10 digit number without any space.");
        _this.find('button[type="submit"]').attr('aria-busy', false);
        return;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      // Basic Validation
      if (!emailRegex.test(email)) {
        _this.find('.banner--error')
            .show()
            .find('.banner__content')
            .html("Please enter a valid email address.");
            _this.find('button[type="submit"]').attr('aria-busy', false);
        return;
      }
  
      $.ajax({
        url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
        method: "POST",
        contentType:"application/json",
        headers: {
          "Authorization": "a6b2b7b25aaf43e1b8ce2491d437801e"
        },
        data: JSON.stringify({
          email: email,
          phone: phone,
          tag: 'Newsletter'
        }),
        success: function (response) {
          console.log(response);
          if(response.status == 1){
            _this.find('.banner--success .banner__content').html(response.message);
            _this.find('.banner--success').show();  
          }else{
            _this.find('.banner--error .banner__content').html(response.message);
            _this.find('.banner--error').show();
          }
          _this.find('button[type="submit"]').attr('aria-busy', false);
        },
        error: function (xhr, status, error) {
          console.log(xhr, status, error);
          _this.find('.banner--error').show();
        }
      });
                   
    }); 
  }  

  $('body').on('click','.coupon_code_wrapper', function(){
    var _this = this;
    var code = $(this).attr('data-code');
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(code).select();
    document.execCommand("copy");
    $temp.remove();
    $(_this).find('.copyicon').hide();
    $(_this).find('.copied').show();
    setTimeout(function(){
      $(_this).find('.copyicon').show();
      $(_this).find('.copied').hide();
    },3000);
  });

  $('body').on('click', '.product-meta_accordion-item_title', function (e) {
    $(this).toggleClass('active');
    $(this).next('.product-meta_accordion-item_content').slideToggle();
  })

  $("body").on("click", ".product-meta-accordion-title", function () {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".product-meta-accordion-content");
    $(".product-meta-accordion-title").not(activeTitle).removeClass("active");
    $(".product-meta-accordion-content").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });
  
  $("body").on("click", ".product-meta_offers-item_copy-code", function () {
    var copy_text = $(this).find('.coupon_offer-item-copy-code');
    var text = $(this).attr('data-code');
    var copy_svg = $(this).find('.coupon_offer-item-copy-code').html();
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
    copy_text.html('Copied');
      
    setTimeout(function () {
      copy_text.html(copy_svg);
    }, 1000);
  });

  // $(window).on("scroll", function () {
  //   var scrollTop = $(window).scrollTop();
  //   var windowHeight = $(window).height();

  //   $(".product-featured-inr-desk-content-item").each(function (index) {
  //     var $this = $(this);
  //     var offsetTop = $this.offset().top;
  //     var offsetBottom = offsetTop + $this.outerHeight();

  //     // 🔥 element viewport me enter ho gaya (top ya bottom se)
  //     if (offsetBottom > scrollTop && offsetTop < scrollTop + windowHeight) {
        
  //       $(".product-featured-inr-desk-media img").removeClass("active");

  //       $(".product-featured-inr-desk-media img")
  //         .eq(index)
  //         .addClass("active");
  //     }
  //   });
  // });

  // let lastIndex = -1;

  // $(window).on("scroll", function () {
  //   var scrollTop = $(window).scrollTop();
  //   var windowHeight = $(window).height();

  //   var activeIndex = -1;

  //   $(".product-featured-inr-desk-content-item").each(function (index) {
  //     var $this = $(this);
  //     var offsetTop = $this.offset().top;
  //     var offsetBottom = offsetTop + $this.outerHeight();

  //     // 🔥 element viewport me aate hi detect
  //     if (offsetBottom > scrollTop && offsetTop < scrollTop + windowHeight) {
  //       activeIndex = index;
  //       return false; // ✅ break loop (important)
  //     }
  //   });

  //   // ✅ sirf tab change karo jab index change ho
  //   if (activeIndex !== -1 && activeIndex !== lastIndex) {
  //     lastIndex = activeIndex;

  //     $(".product-featured-inr-desk-media img")
  //       .removeClass("active")
  //       .eq(activeIndex)
  //       .addClass("active");
  //   }
  // });

});
$(document).ready(function(){
  if (window.matchMedia("(min-width: 1000px)").matches) {
    var $section = $(".product-featured-inner-desktop");
    if(!$section.length) return;
  
    var $contents = $section.find(".product-featured-inr-desk-content-item");
    var $images = $section.find(".product-featured-item_img");
  
    var activeIndex = 0;
    var lastScroll = $(window).scrollTop();
  
    function changeImage(newIndex, direction){

      if(newIndex === activeIndex) return;

      var $current = $images.eq(activeIndex);
      var $next = $images.eq(newIndex);

      var $current_content = $contents.eq(activeIndex);
      var $next_content = $contents.eq(newIndex);

      if(!$next.length) return;

      // hide current image
      if(activeIndex !== 0){
        $current.css({
          clipPath: direction === "down" ? "inset(0 0 100% 0)" : "inset(100% 0 0 0)"
        });
      }

      // update content opacity
      $contents.css({ opacity: 0 });
      $next_content.css({ opacity: 1 });

      // if returning to first image
      if(newIndex === 0){
        $images.not(":first").css({ clipPath: "inset(100% 0 0 0)" });

        $contents.css({ opacity: 0 });
        $contents.eq(0).css({ opacity: 1 });

        activeIndex = 0;
        return;
      }

      // prepare next image
      $next.css({
        transition: "none",
        clipPath: direction === "down" ? "inset(100% 0 0 0)" : "inset(0 0 100% 0)"
      });

      requestAnimationFrame(function(){
        $next.css({
          transition: "clip-path .6s cubic-bezier(.99,.01,.5,.94)",
          clipPath: "inset(0 0 0 0)"
        });
      });

      activeIndex = newIndex;
    }
  
    function handleScroll(){
      var currentScroll = $(window).scrollTop();
      var direction = currentScroll > lastScroll ? "down" : "up";
      lastScroll = currentScroll;
  
      var newIndex = 0;
      var trigger = $(window).height() * 0.75;
  
      $contents.each(function(index){
        var rect = this.getBoundingClientRect();
  
        if(rect.top < trigger){
          newIndex = index;
        }
      });
      changeImage(newIndex, direction);
    }
    $(window).on("scroll", handleScroll);
  }
});


// document.addEventListener("DOMContentLoaded", function () {

//   const section = document.querySelector(".product-featured-inner-desktop");
//   if (!section) return;

//   const contents = section.querySelectorAll(".product-featured-inr-desk-content-item");
//   const images = section.querySelectorAll(".product-featured-item_img");

//   let activeIndex = 0;
//   let lastScroll = window.scrollY;

//   function changeImage(newIndex, direction) {

//     if (newIndex === activeIndex) return;

//     const current = images[activeIndex];
//     const next = images[newIndex];

//     if (!next) return;

//     // hide current image
//     current.style.clipPath =
//       direction === "down"
//         ? "inset(0 0 100% 0)"
//         : "inset(100% 0 0 0)";

//     current.style.opacity = "1";

//     // prepare next image
//     next.style.transition = "none";
//     next.style.opacity = "1";

//     next.style.clipPath =
//       direction === "down"
//         ? "inset(100% 0 0 0)"
//         : "inset(0 0 100% 0)";

//     requestAnimationFrame(() => {
//       next.style.transition =
//         "clip-path .6s cubic-bezier(.99,.01,.5,.94), opacity .3s";
//       next.style.clipPath = "inset(0 0 0 0)";
//     });

//     activeIndex = newIndex;
//   }

//   function handleScroll() {

//     const direction = window.scrollY > lastScroll ? "down" : "up";
//     lastScroll = window.scrollY;

//     let newIndex = 0;

//     contents.forEach((item, index) => {

//       const rect = item.getBoundingClientRect();
//       const trigger = window.innerHeight * 0.45;

//       if (rect.top < trigger) {
//         newIndex = index;
//       }

//     });

//     changeImage(newIndex, direction);
//   }

//   window.addEventListener("scroll", handleScroll);

// });

